import type { T_HOME_INSPECTION_TYPES } from '@app/listing/constants';
import type { AppointmentType } from '@bb/domain/dist/types';

export type OverrideOptionType = Extract<
  AppointmentType,
  | 'Home Inspection'
  | 'Appraisal'
  | T_HOME_INSPECTION_TYPES
  | 'Buyer Visit'
  | 'Photographer'
  | 'Pest Control'
  | 'Final Walkthrough'
>;

export enum ShowingScreenType {
  /** no booking allowed at all */
  Forbid = 'Forbid',
  /** (internal only) users with permission can just override && book */
  AdminOverride = 'AdminOverride', //
  /** users without permission can select a reason to override && book */
  AgentOverride = 'AgentOverride', // users without permission can select a reason to override && book
  /** just go to normal booking flow, no override needed. */
  Default = 'Default',
}
